// extracted by mini-css-extract-plugin
module.exports = {"desc":"CGMsjbic","title":"ER8JjFOu","list":"pASKBRZK","desc-item":"FsiHhOI5","icon":"__9PbTNRUU","circle":"cxHUZ6I3"};